import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IDebtRollover } from '../interface/DebitRollover/IDebtRollover';
import { IRolloverTradesResponse } from '../interface/DebitRollover/IRolloverTradesResponse';
import { IRolloverTradesRequest } from '../interface/DebitRollover/IRolloverTradesRequest';
import { IPostPurchasePendenciesItem } from '../interface/DebitRollover/IPostPurchasePendenciesItem';
import { IDebtRolloverEntubaRequest } from '../interface/entuba/debtRollover/IDebtRolloverEntubaRequest';
import { IDebtRolloverApproval } from '../interface/settlements/IReconciledSettlementApprove';
import { PostPurchasePendenciesEnum } from '../enum/settlements/PostPurchasePendenciesEnum';

enum DebtRolloverServiceEnum {
  base = "/",
  executeActions = "/execute-actions",
  getAllStatuses = "/statuses",
  starEntuba = "/start-entuba",
  approveOrRejectAction = "/approve",
  getToApprove = "/get-to-approve"
}

export default class DebtRolloverService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/debt-rollover");
  }

  public getAll = async (): Promise<IDebtRollover[]> => await this.GET(DebtRolloverServiceEnum.base);
  public startEntuba = async (data: IDebtRolloverEntubaRequest) => await this.PUT(DebtRolloverServiceEnum.starEntuba, data);
  public getAllStatuses = async (data: PostPurchasePendenciesEnum[]): Promise<IPostPurchasePendenciesItem[]> => await this.PUT(DebtRolloverServiceEnum.getAllStatuses, data);
  public executeActions = async (data: IRolloverTradesRequest): Promise<IRolloverTradesResponse[]> =>
    await this.POST(DebtRolloverServiceEnum.executeActions, data);

  public getToApprove = async (): Promise<IDebtRolloverApproval[]> => await this.GET(DebtRolloverServiceEnum.getToApprove);
  public ApproveOrRejectAction = async (data: IDebtRolloverApproval): Promise<void> => await this.POST(DebtRolloverServiceEnum.approveOrRejectAction, data);
}